export const data = [
    {
        "title": "How is an AI survey different from a regular survey?",
        "description": "Magic AI survey looks and feels just like a regular survey: you can ask the same types of questions and customize it in same way. However, unlike a regular survey, Magic AI survey, is able to understand your customer’s answers in real time and ask great follow up questions. This unlocks deeper and more actionable insights.",
    },
    {
        "title": "Is it possible to customize Magic AI Survey?",
        "description": "Absolutely! Magic AI Survey can be customized to the look and feel of your unique brand.",
    },
    {
        "title": "Will Magic Survey’s AI get smarter over time? ",
        "description": "Yes. Magic Feedback’s unique advantage is that we have built our own AI model. This allows us to ensure continuous improvement of outputs generated over time. Additionally, we continue to leverage the latest technical innovations available, resulting in significant accuracy improvements. "
    },
    {
        "title": "How does Magic AI Survey ensure the privacy and security of my data?",
        "description": "Magic Feedback prides itself with the creation of a closed system. Once your customer’s data enters our European servers, it is protected with the highest grade of Enterprise Security. The data never leaves our servers, and is not accessed by a Third-Party party tool. Please find more information on how we use personal information on our privacy page."
    },
    {
        "title": "What integrations does Magic AI Surveys support? ",
        "description": "Magic AI Surveys integrate with all your essential apps. We integrate with: Zapier, Google Sheets, Slack, Hubspot, Salesforce and many more. Get in touch and we would answer all your questions. "
    }
]
